module.exports = __webpack_public_path__ + "static/media/graphql.1bcf5ba8.png";